






import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Columns extends Vue {
  constructor() {
    super();
  }
}
